const getBenefits = (partnerName: string) => [
  'Email, phone, and text',
  `Hide ${partnerName} branding`,
  'Full AI assistant customizations',
  'And much more!',
]

export default getBenefits
